import { useFetchConnectedIntegrations } from '@modules/integrationsV2/hooks';
import { mapConnectedIntegrationToWorkspaces } from '@modules/integrationsV2/utils';
import { IntegrationChannelType, IntegrationType } from 'generated/graphql';

interface UseGetConnectedIntegrationsOptions {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const useGetConnectedIntegrationWorkspaces = ({
  channelType,
  integrationType,
}: UseGetConnectedIntegrationsOptions) => {
  const { connectedIntegrations } = useFetchConnectedIntegrations({
    fetchPolicy: 'cache-first',
  });

  const filteredIntegrations = connectedIntegrations.filter(
    (integration) =>
      integration.channel.type === channelType &&
      integration.integrationType === integrationType &&
      integration.isActive,
  );

  const connectedWorkspaces =
    mapConnectedIntegrationToWorkspaces(filteredIntegrations);

  return connectedWorkspaces;
};
